import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
const Index = () => import("@/containers/Index/Index");
const Flow = () => import("@/containers/Advantage/Flow");
const Ai = () => import("@/containers/Advantage/Ai");
const Dimension = () => import("@/containers/Advantage/Dimension");
const Content = () => import("@/containers/Advantage/Content");
const Case = () => import("@/containers/Case/Case");
const CaseContent = () => import("@/containers/Case/CaseContent");
const News = () => import("@/containers/News/News");
const NewsContent = () => import("@/containers/News/NewsContent");
const FlowToCash = () => import("@/containers/Flow/FlowToCash");
const Publishers = () => import("@/containers/Flow/Publishers");
const About = () => import("@/containers/About/About");

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
	// 首页，默认首页
	{
		path: "/",
		component: Index
	},
	// 首页
	{
		path: "/index",
		redirect: "/"
	},
	// 品质流量
	{
		path: "/flow",
		component: Flow
	},
	// ai赋能
	{
		path: "/ai",
		component: Ai
	},
	// 内容场景
	{
		path: "/content",
		component: Content
	},
	// 多维服务
	{
		path: "/dimension",
		component: Dimension
	},
	// 成功案例
	{
		path: "/case",
		component: Case
		// props: true
	},
	// 成功案例-具体案例
	{
		path: "/case_content/:id",
		component: CaseContent
	},
	// 流量变现
	{
		path: "/flow_to_cash",
		component: FlowToCash
	},
	{
		path: "/Publishers",
		component: Publishers
	},
	// 新闻资讯
	{
		path: "/news",
		component: News
	},
	// 新闻资讯-具体新闻
	{
		path: "/news_content/:id",
		component: NewsContent
	},
	// 关于我们
	{
		path: "/about",
		component: About
	}
];

var router = new VueRouter({
	mode: "history",
	routes
	// scrollBehavior (to, from, savedPosition) {
	//     console.log(111)
	//     if (savedPosition) {
	//         to.meta.saved_position = savedPosition;
	//         // 现在原页面滚动 如果滚动高度超过页面自身高度，就回到顶部
	//         // return savedPosition;
	//         window.scrollTo(savedPosition.x, savedPosition.y);
	//     } else {
	//         window.scrollTo(0, 0);
	//     }
	// }
});
// 全局路由守卫
router.beforeEach((to, from, next) => {
	next();
});
router.afterEach((to, from, next) => {
	// 置顶
	window && window.scrollTo(0, 0);
	document && document.documentElement.click();
	// next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router.js